
(function () {
  'use strict';

  const bag = document.getElementById('jica-bag');
  const overlay = document.getElementById('jica-bag-overlay');
  if (!bag || !overlay) return;

  const items = document.getElementById('jica-bag-items');
  const count = document.getElementById('jica-bag-count');
  const subtotal = document.getElementById('jica-bag-subtotal');
  const close = document.getElementById('jica-bag-close');
  const continueButton = document.getElementById('jica-bag-continue');

  function money(pence) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(pence / 100);
  }

  function escapeHTML(value) {
    const el = document.createElement('span');
    el.textContent = String(value || '');
    return el.innerHTML;
  }

  async function refreshBag() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();
      count.textContent = cart.item_count;
      subtotal.textContent = money(cart.total_price);

      if (!cart.items.length) {
        items.innerHTML = '<p>Your bag is currently empty.</p>';
        return;
      }

      items.innerHTML = cart.items.map(item => `
        <div class="jica-bag-item">
          ${item.image
            ? `<img src="${escapeHTML(item.image)}"
                    alt="${escapeHTML(item.product_title)}"
                    width="72">`
            : ''}
          <div>
            <strong>${escapeHTML(item.product_title)}</strong>
            <div class="jica-bag-quantity">
  <button type="button" class="jica-qty-minus"
    data-key="${item.key}"
    aria-label="Decrease quantity">−</button>
  <span>${item.quantity}</span>
  <button type="button" class="jica-qty-plus"
    data-key="${item.key}"
    aria-label="Increase quantity">+</button>
  <button type="button" class="jica-qty-remove"
    data-key="${item.key}">Remove</button>
</div>
            <p>${money(item.final_line_price)}</p>
          </div>
        </div>
      `).join('');
    } catch (error) {
      items.textContent = 'Unable to load your bag. Please try again.';
      console.error('JICA bag:', error);
    }
  }
async function changeBagQuantity(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, quantity)
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update bag');
    }

    await refreshBag();
  } catch (error) {
    console.error('Bag quantity update failed:', error);
    alert('Unable to update your bag. Please try again.');
  }
}
  function openBag() {
    overlay.hidden = false;
    bag.classList.add('is-open');
    bag.setAttribute('aria-hidden', 'false');
    bag.setAttribute('tabindex', '-1');
    document.body.classList.add('jica-bag-open');
    refreshBag();
    close.focus();
  }

  function closeBag() {
    bag.classList.remove('is-open');
    bag.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('jica-bag-open');
  }

  close.addEventListener('click', closeBag);
  continueButton.addEventListener('click', closeBag);
  overlay.addEventListener('click', closeBag);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeBag();
  });
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.jica-bag-trigger');
  if (!trigger) return;

  event.preventDefault();
  openBag();
});
items.addEventListener('click', function(event) {
  const button = event.target.closest('button');
  if (!button) return;

  const key = button.dataset.key;
  if (!key) return;

  const quantityElement = button
    .closest('.jica-bag-quantity')
    ?.querySelector('span');

  const quantity = Number(quantityElement?.textContent || 0);

  if (button.classList.contains('jica-qty-minus')) {
    changeBagQuantity(key, quantity - 1);
  }

  if (button.classList.contains('jica-qty-plus')) {
    changeBagQuantity(key, quantity + 1);
  }

  if (button.classList.contains('jica-qty-remove')) {
    changeBagQuantity(key, 0);
  }
});
  // Temporary test function, for use in browser console.
  window.JicaBag = {
    open: openBag,
    close: closeBag,
    refresh: refreshBag
  };
  
document.addEventListener('submit', async function(event) {
  const form = event.target.closest('form.nmv4-buy-form');
  if (!form) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const button = form.querySelector('[type="submit"]');
  if (button) button.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to add product to cart');
    }

    openBag();

  } catch (error) {
    console.error('Nail Magic add to cart failed:', error);
    alert('Sorry, we could not add this item. Please try again.');
  } finally {
    if (button) button.disabled = false;
  }
}, true);
})();